import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../services/api.tsx";

const ActivatePage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("Aktivasyon yapılıyor...");

  useEffect(() => {
    const email = searchParams.get("email");
    const token = searchParams.get("token");

    const confirmEmail = async () => {
      try {
        await api.get(`/api/auth/confirm-email?email=${email}&token=${token}`);
        setStatus("E-posta başarıyla doğrulandı! Giriş yapabilirsiniz.");
      } catch {
        setStatus("Aktivasyon başarısız. Lütfen tekrar deneyin.");
      }
    };

    confirmEmail();
  }, [searchParams]);

  return (
    <div className="p-8 text-center">
      <h2 className="text-2xl font-bold">{status}</h2>
    </div>
  );
};

export default ActivatePage;
